import { render, staticRenderFns } from "./FormDeletePersonalRate.vue?vue&type=template&id=ccfc4360&"
import script from "./FormDeletePersonalRate.vue?vue&type=script&lang=ts&"
export * from "./FormDeletePersonalRate.vue?vue&type=script&lang=ts&"
import style0 from "./FormDeletePersonalRate.vue?vue&type=style&index=0&id=ccfc4360&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports